<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-briefcase"></i> Comarca</h3>
      </div>
    </div>
    <ComarcaAdd v-if="showAdd" ref="ComarcaAdd" v-on:Back="onBack" />
    <ComarcaList v-else ref="ComarcaList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import ComarcaAdd from './components/add/comarcaadd.vue'
import ComarcaList from './components/list/comarcalist.vue'

export default {
  name: 'Comarca',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    ComarcaAdd,
    ComarcaList
  },
  mounted () { },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.ComarcaAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/ajuizamento/comarca/comarca.vue